import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AssetList } from '@goldcast/api/content';
import { Clip } from '@goldcast/player-config/src/types/clip-types';
import { isDuplicateRecordingAsset } from '@/libs/duplicateAsset';

export default function useClipNavigate() {
  const navigate = useNavigate();

  const navigateToClip = useCallback(
    (clipData: Clip | AssetList, { downloadIntent }: { downloadIntent: boolean }) => {
      if (clipData.saved_search) {
        navigate(`/search/${clipData.saved_search.id}/clips?activeClipId=${clipData.id}`, {
          state: { downloadIntent }
        });
        return;
      }
      // Duplicate recordings live on the recordings route, selected via `activeDuplicateId`.
      if (isDuplicateRecordingAsset(clipData)) {
        navigate(
          `/${clipData.content!.project.id}/${clipData.content!.id}/recordings?activeDuplicateId=${clipData.id}`,
          { state: { downloadIntent } }
        );
        return;
      }
      navigate(`/${clipData.content!.project.id}/${clipData.content!.id}/clips?activeClipId=${clipData.id}`, {
        state: { downloadIntent }
      });
    },
    [navigate]
  );

  return {
    navigateToClip
  };
}
